/**
 * Created by Wang.Qiong on 2021/9/11.
 */
import React, { useState, useEffect } from 'react'
import { Modal, Input, Button, Table, message, Empty, Form } from 'antd';
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import UploadForm from '../../../components/common/Uploads/uploadUtils'
import { getQiNiuToken } from '../../../utils/api'
import Particulars from './Particulars'
import { saveNews } from '../../../utils/api'
import { FILEACTIONURL } from '../../../config/index';
const { TextArea } = Input;
function Construction(props) {
    const [editor, setEditor] = useState(null) // 存储 editor 实例
    const [html, setHtml] = useState('') // 编辑器内容
    const [form] = Form.useForm();
    const [token, setToken] = useState();
    const [contentArr, setContentArr] = useState();
    const [title, setTitle] = useState();
    const [headline, setHeadline] = useState();
    const [cover, setCover] = useState();
    const [particularsVisible, handleParticularsVisible] = useState(false);
    const [particularsContent, setParticularsContent] = useState({});
    form.resetFields();
    // useEffect(() => {
    //     setTimeout(() => {
    //         setHtml('<p>hello&nbsp;world</p>')
    //     }, 1500)
    // }, [])
    const toolbarConfig = {}

    const editorConfig = {
        placeholder: '请输入内容...',
        onCreated(editor) {
            console.log(editor)
            setEditor(editor);
        }, // 记录下 editor 实例，重要！
        onChange: (editor) => {
            // editor 选区或者内容变化时，获取当前最新的的 content
            console.log('html', editor.getHtml());
            setContentArr(editor.getHtml());
        },
        MENU_CONF: {
            // 配置字号
            // fontSize: [ 2,4,6,8,10 ],

            // 配置上传图片
            uploadImage: {
                fieldName: 'file',
                // server: 'https://up-z0.qiniup.com',
                server: FILEACTIONURL,
                meta: {
                    output: 'json',
                    scene: 'pubuilcHouse',
                    // token:  localStorage.getItem('qiniuToken'),
                    // token: token,
                },
                maxFileSize: 10 * 1024 * 1024,
                customInsert(res, insertFn) {
                    // res 即服务端的返回结果
                    console.log('4444444444:', res);
                    // 从 res 中找到 url alt href ，然后插图图片
                    // insertFn('https://qiniu.toseesoft.net/' + res?.key);
                    insertFn(res?.src);
                },
            },
            // 配置上传视频
            uploadVideo: {
                fieldName: 'file',
                // server: 'https://up-z0.qiniup.com',
                server: FILEACTIONURL,
                meta: {
                    token:  localStorage.getItem('qiniuToken'),
                    // token: token,
                },
                maxFileSize: 10 * 1024 * 1024,
                customInsert(res, insertFn) {
                    // res 即服务端的返回结果
                    console.log('4444444444:', res);
                    // 从 res 中找到 url alt href ，然后插图图片
                    // insertFn('https://qiniu.toseesoft.net/' + res?.key);
                    insertFn(res?.src);
                },
            }
            // 继续其他菜单配置
        },
    };
    // 及时销毁 editor ，重要！
    useEffect(async () => {
        const result = await getQiNiuToken();
        if (result) {
            localStorage.setItem('qiniuToken',result)
            setToken(result);
        }
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])
    const fileUrl = (imgArr) => {
        console.log(imgArr);
        setCover(imgArr[0])
        form.setFieldsValue({ content: imgArr.toString() });

    };
    const onSubmint = async (type) => {
        let opt = {}
        opt.title = title
        opt.subtitle = headline
        opt.context = contentArr
        opt.imgs = cover
        if(!title || !contentArr || !cover){
            message.error('请输入标题,内容及封面')
            return
        }
        // 判断用户信息是否存在
        if (!props.userLoginInfo) {
            message.error('请先登录')
            this.props.history.push({ pathname: '/login' })
        } else {
            opt.author = props.userLoginInfo.username
            opt.operator = props.userLoginInfo.username
        }

        if (type === '') {
            setParticularsContent(opt)
        } else {
            opt.status = type
            let data = await saveNews(opt)
            if (data.code == 0) {
                message.success('新建新闻成功')
                props.getPages()
                props.handleConstructionVisible(false)
            } else {
                message.error(data.message)
            }
        }

    }
    // 点击详情
    useEffect(async () => {
        if (JSON.stringify(particularsContent) != '{}') {
            handleParticularsVisible(true)
        }
    }, [particularsContent])
    return (
        <div >
            <Modal
                className='changeNew'
                title="新建新闻"
                centered
                visible={props.constructionVisible}
                // onOk={this.props.handleConstructionVisible()}
                onCancel={() => props.handleConstructionVisible(false)}
                width={900}
                height={400}
                footer={[
                    <Button onClick={() => onSubmint('')}>
                        预览
                    </Button>,
                    <Button onClick={() => onSubmint(0)} style={{ background: '#0093D8', color: '#fff' }}>
                        发布
                    </Button>,
                    <Button onClick={() => onSubmint(1)} style={{ background: '#0093D8', color: '#fff' }}>
                        发布重要新闻
                    </Button>,
                    <Button onClick={() => onSubmint(3)} >
                        存草稿
                    </Button>,
                    <Button onClick={() => props.handleConstructionVisible(false)}>
                        取消
                     </Button>
                ]}
            >
                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                    <Toolbar
                        editor={editor}
                        defaultConfig={toolbarConfig}
                        mode="default"
                        style={{ borderBottom: '1px solid #ccc' }}
                    />
                    <Editor
                        defaultConfig={editorConfig}
                        value={html}
                        onCreated={setEditor}
                        onChange={editor => setHtml(editor.getHtml())}
                        mode="default"
                        style={{ height: '500px', 'overflow-y': 'hidden' }}
                    />
                </div>
                <Form>
                    <Form.Item
                        label="标题："
                        name="title"
                        rules={[{ required: true, message: '请输入标题!' }]}
                        style={{width:'70%'}}
                    >
                        <Input onChange={(e) => { setTitle(e.target.value) }} />
                    </Form.Item>
                    <div style={{ display: "flex", }}>

                        <Form.Item
                            label="封面和副标题："
                            name="cover"
                            // style={{display:'inline-block'}}
                            width={500}
                            
                        >
                            <UploadForm fileUrl={fileUrl} />
                        </Form.Item>
                        <Form.Item
                            width={300}
                            name="headline"
                        >
                            <TextArea
                                onChange={(e) => { setHeadline(e.target.value) }}
                                showCount
                                maxLength={100}
                                style={{
                                    width: 350,
                                }}
                            // onChange={onChange}
                            />
                        </Form.Item>
                    </div>
                </Form>
            </Modal>
            <Particulars particularsContent={particularsContent} particularsVisible={particularsVisible} handleParticularsVisible={handleParticularsVisible} />
        </div>
    )

}
export default Construction;
